  // ── Built-in SVG icon library ─────────────────────────────────────────────
  const BOTTOM_NAV_ICONS = {
    home: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512" stroke="currentColor">
      <title xmlns="" stroke="currentColor">home-outline</title>
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" 
            d="M80 212v236a16 16 0 0 0 16 16h96V328a24 24 0 0 1 24-24h80a24 24 0 0 1 24 24v136h96a16 16 0 0 0 16-16V212"/>
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" 
            d="M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69"/>
      </svg>`,
 
    stats: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="2"  y="14" width="5" height="8" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="9"  y="9"  width="5" height="13" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="16" y="3"  width="5" height="19" rx="1" stroke="currentColor" stroke-width="1.5"/>
    </svg>`,
 
    admin: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="2" width="20" height="20" rx="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M7 9h10M7 12h10M7 15h6"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,
 
    profile: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
      <path d="M3 21c0-4.418 4.03-8 9-8s9 3.582 9 8"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,
 
    logout: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M10 3H4a1 1 0 00-1 1v16a1 1 0 001 1h6"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M16 17l4-4-4-4M9 12h12"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
 
    coffee: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M4 8h13v9a4 4 0 01-4 4H8a4 4 0 01-4-4V8z"
            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
      <path d="M17 10h2a3 3 0 010 6h-2"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M8 4c0-1.5 2-2 2-4M13 4c0-1.5 2-2 2-4"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,
 
    bell: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 3a7 7 0 00-7 7v4l-2 3h18l-2-3v-4a7 7 0 00-7-7z"
            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
      <path d="M10 20a2 2 0 004 0"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,
 
    settings: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41
               M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,
 
    users: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
      <path d="M2 21c0-4.418 3.134-8 7-8s7 3.582 7 8"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M18 10c2.21 0 4 1.79 4 4"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="18" cy="6" r="3" stroke="currentColor" stroke-width="1.5"/>
    </svg>`,
 
    wallet: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M2 10h20M7 7V5a2 2 0 012-2h6a2 2 0 012 2v2"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="17" cy="15" r="1.5" fill="currentColor"/>
    </svg>`,
 
    search: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
      <path d="M16 16l4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`,

    messages: `<svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
      <path fill="#ffffff" d="M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224H128zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64z"/>
      <path fill="#ffffff" d="M904 224 656.512 506.88a192 192 0 0 1-289.024 0L120 224h784zm-698.944 0 210.56 240.704a128 128 0 0 0 192.704 0L818.944 224H205.056z"/>
    </svg>`,
  };
 
  class BottomNav extends HTMLElement {
 
    // ── A. Shadow DOM setup ──────────────────────────────────────────────
    constructor() {
      super();
      this._shadow    = this.attachShadow({ mode: "open" });
      this._items     = [];
      this._activeId  = null;
      this._user      = {};
      this._handlers  = {}; // per-item callback registry
    }
 
    // ── B. Lifecycle ─────────────────────────────────────────────────────
    connectedCallback() {
      this._render();
    }
 
    // ── C. JS property setter ────────────────────────────────────────────
    set items(data) {
      this._items    = Array.isArray(data) ? data.slice(0, 5) : [];
      this._activeId = this._items.find(i => i.active)?.id
                    ?? this._items[0]?.id
                    ?? null;
      this._render();
    }

    set user(data) {
      this._user     = data;
      //console.log("USER ROLES: %o", this._user.roles);
      this._items.forEach(i => {
        
        //console.log("ITEM ROLE: %o", i.role);
        if (!i.role) {
          //console.log("don't touch item %o", i);
        } else if (this._user.roles.includes(i.role)) {
          //console.log("don't touch item %o", i);
        } else {
          //console.log("disabling item %s", i.id);
          i.disabled = true;
        }
      });
      
      this._render();
    }
 
    // ── D. Attribute → property bridge ───────────────────────────────────
    static get observedAttributes() { return ["items"]; }
    attributeChangedCallback(name, _, newVal) {
      if (name === "items") {
        try { this.items = JSON.parse(newVal); } catch {}
      }
    }
 
    // ── E. Register a per-item click handler ─────────────────────────────
    // Usage: nav.onSelect("logout", () => signOut());
    onSelect(id, fn) {
      this._handlers[id] = fn;
    }
 
    // ── F. Programmatically activate an item ─────────────────────────────
    setActive(id) {
      if (!this._items.find(i => i.id === id)) return;
      this._activeId = id;
      this._updateActive();
    }
 
    // ── G. Update badge count on a specific item at runtime ───────────────
    setBadge(id, count) {
      const item = this._items.find(i => i.id === id);
      if (item) {
        item.badge = count;
        const badgeEl = this._shadow.querySelector(`[data-id="${id}"] .badge`);
        if (badgeEl) {
          badgeEl.textContent = count > 99 ? "99+" : count > 9 ? "9+" : String(count);
          badgeEl.style.display = count > 0 ? "flex" : "none";
        }
      }
    }
 
    // ── H. Handle a tap ──────────────────────────────────────────────────
    _handleTap(id) {
      const item = this._items.find(i => i.id === id);
      if (!item || item.disabled) {
        console.log("item %s is disabled", id);
        return;
      }
      if (!item.role || this._user.roles.includes(item.role)) {
 
        this._activeId = id;
        this._updateActive();
  
        // Fire registered per-item handler
        if (typeof this._handlers[id] === "function") {
          this._handlers[id](item);
        }
  
        // Fire CustomEvent for the host page
        this.dispatchEvent(new CustomEvent("nav-select", {
          detail: { ...item },
          bubbles: true,
          composed: true,
        }));
      } else {
        console.log("item %s is alowed only for users with role '%s'", id, item.role);
        console.log("USER ROLES: %o", this._user.roles);
        console.log("ITEM ROLE: %o", item.role);
        
        return;
      }
    }
 
    // ── I. Swap active class without full re-render ───────────────────────
    _updateActive() {
      this._shadow.querySelectorAll(".item").forEach(el => {
        const isActive = el.dataset.id === this._activeId;
        el.classList.toggle("active", isActive);
        el.setAttribute("aria-current", isActive ? "page" : "false");
      });
    }
 
    // ── J. Build HTML for a single nav item ──────────────────────────────
    _itemHTML(item) {
      const isActive  = item.id === this._activeId;
      const iconSVG   = BOTTOM_NAV_ICONS[item.icon] || BOTTOM_NAV_ICONS["home"];
      const badgeHTML = item.badge
        ? `<span class="badge" aria-label="${item.badge} notifications">
             ${item.badge > 99 ? "99+" : item.badge > 9 ? "9+" : item.badge}
           </span>`
        : `<span class="badge hidden" aria-label="${item.badge} notifications"></span>`;
 
      return `
        <button class="item${isActive ? " active" : ""}${item.disabled ? " disabled" : ""}"
                data-id="${item.id}"
                aria-label="${item.label}"
                aria-current="${isActive ? "page" : "false"}"
                ${item.disabled ? "disabled" : ""}
                role="tab">
          ${badgeHTML}
          <span class="icon">${iconSVG}</span>
          <span class="label">${item.label}</span>
        </button>`;
    }
 
    // ── K. Full render ────────────────────────────────────────────────────
    _render() {
      const itemsHTML = this._items.map(i => this._itemHTML(i)).join("");
 
      this._shadow.innerHTML = `
        <style>
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
 
          :host {
            display: block;
            /* Stick to the bottom of the viewport */
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1000;
            font-family: system-ui, sans-serif;
          }
 
          nav {
            background: transparent;
            border-top: 0.5px solid #e0dfd7;
            display: flex;
            align-items: stretch;
            /* Respect iPhone home indicator */
            padding-bottom: env(safe-area-inset-bottom, 0px);
          }
 
          .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 4px;
            padding: 14px 4px 18px;
            cursor: pointer;
            border: 0.5px solid #e0dfd7;
            border-radius: 5px 5px 0px 0px;
            /*background: transparent;*/
            background: #5D4037;
            color: #ffffff;
            transition: color 0.15s, background 0.15s;
            position: relative;
            -webkit-tap-highlight-color: transparent;
            min-width: 0;
            /* Minimum 44px tap target height (Apple HIG) */
            min-height: 56px;
          }
 
          .item:hover:not(.disabled) { 
            /*background: #f5f5f3; */
            .label {
              font-size: 12px;
              font-weight: 900;
            }
          }
          .item:active:not(.disabled) { background: #f5f5f3; transform: scale(0.96); }
          .item:focus-visible { outline: 2px solid #4a90d9; outline-offset: -2px; }
 
          /* Active indicator — top bar */
          .item.active {
            color: #ffffff;
            .label {
              font-size: 12px;
              font-weight: 500;
            }
          }
 
          .item.active::after {
            content: "";
            position: absolute;
            top: 0;
            left: 20%;
            right: 20%;
            height: 5px;
            border-radius: 0 0 2px 2px;
            background: #f20606;
          }
 
          .item.disabled {
            color: #d0cfc7;
            cursor: not-allowed;
          }
 
          .icon {
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-top: 2px;
          }
 
          .label {
            font-size: 10px;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            max-width: 100%;
            text-overflow: ellipsis;
            line-height: 1;
          }
 
          /* Notification badge */
          .badge {
            position: absolute;
            top: 12px;
            right: calc(50% - 22px);
            min-width: 16px;
            height: 16px;
            border-radius: 99px;
            background: #e24b4a;
            color: #fff;
            font-size: 9px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 4px;
            /* Separate from the icon */
            border: 2px solid #fff;
            line-height: 1;
          }
          .badge.hidden {
            display: none;
          }
 
          /*
          @media (prefers-color-scheme: dark) {
            nav { background: #1e1e1c; border-top-color: #333330; }
            .item { color: #5F5E5A; }
            .item:hover:not(.disabled) { background: #2a2a28; }
            .item:active:not(.disabled) { background: #2a2a28; }
            .item.active { color: #f0ede8; }
            .item.active::after { background: #f0ede8; }
            .item.disabled { color: #333330; }
            .badge { border-color: #1e1e1c; }
          }
          */
        </style>
 
        <nav role="tablist" aria-label="Main navigation">
          ${itemsHTML}
        </nav>
      `;
 
      // Bind click events
      this._shadow.querySelectorAll(".item").forEach(el => {
        el.addEventListener("click", () => this._handleTap(el.dataset.id));
        el.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") this._handleTap(el.dataset.id);
          // Arrow key navigation
          if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            const items = [...this._shadow.querySelectorAll(".item:not(.disabled)")];
            const idx   = items.indexOf(el);
            const next  = e.key === "ArrowRight" ? items[idx + 1] : items[idx - 1];
            if (next) next.focus();
          }
        });
      });
    }
  }

export { BottomNav }